import { SuspenseButton } from '@common/components/utility';
import SignaturePad from '@common/components/wrappers/SignaturePad';
import React, { useRef, useState } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';


export interface IUserProfileSignatureAddProps {
    onSubmit: (image: string, applySignatureToClinic?: boolean) => void;
    onCancel: () => void;
    title: string;
    visible: boolean;
    updateInProgress?: boolean;
    showApplySignatureToClinic?: boolean
    tag?: string;
}

export const UserProfileSignatureAdd = ({ onSubmit, onCancel, title, visible, updateInProgress, showApplySignatureToClinic, tag }: IUserProfileSignatureAddProps) => {
    const [applySignatureToClinic, setApplySignatureToClinic] = useState<boolean>(false);
    let signaturePadRef = useRef<SignaturePad>(null);

    const handleClear = () => signaturePadRef?.current?.clear();

    const handleSave = () => {
        if (signaturePadRef?.current && !signaturePadRef.current.isEmpty()) {
            onSubmit(signaturePadRef.current.toDataURL(), applySignatureToClinic);
        }
    }
    const checkboxNotPresent = !showApplySignatureToClinic;
    const checkboxIsChecked = applySignatureToClinic;
    const showDisclaimer = checkboxNotPresent || checkboxIsChecked;
    return (
        <Modal centered className="confirm-dialog modal-signature" show={visible} onHide={onCancel} data-testid="add-signature-modal" backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col style={{ border: "1px solid gray" }}>
                        <SignaturePad height={150} ref={signaturePadRef} />
                    </Col>

                </Row>

                <Row>
                    <Button
                        aria-label="clear"
                        variant="light"
                        className='cancel m-0'
                        onClick={handleClear}>Clear signature</Button>
                </Row>
                {showDisclaimer &&
                    <Row>
                        <SignatureDisclaimer />
                    </Row>
                }
            </Modal.Body>

            <Modal.Footer className="flex-column">
                {showApplySignatureToClinic &&
                    <Row>
                        <Col className="big-checkbox text-primary font-weight-bold" id="signature-checkbox">
                            <Form.Check
                                label="Save and allow using this signature for remaining visits of the day"
                                type="checkbox"
                                checked={applySignatureToClinic}
                                onChange={(e) => {
                                    setApplySignatureToClinic(e.target.checked);
                                }}
                                id={`signatureForDayVerify`} />
                        </Col>
                    </Row>
                }
                <div>
                    <Button
                        aria-label="cancel"
                        variant="light"
                        className='cancel'
                        onClick={onCancel}>Cancel</Button>
                    {tag ?

                        <SuspenseButton
                            tag={tag}
                            className={updateInProgress ? 'button-loading align-items-end' : 'align-items-end'}
                            hideSpinner={false}
                            type="submit"
                            onClick={handleSave}
                            variant="primary" >
                            Save Signature
                        </SuspenseButton>
                        :
                        <Button
                            aria-label="submit"
                            variant="primary"
                            className={updateInProgress ? 'button-loading align-items-end' : 'align-items-end'}
                            disabled={signaturePadRef == null ?? updateInProgress} // disable the submit button if nothing has been drawn.
                            onClick={handleSave}>Save Signature</Button>
                    }
                </div>
            </Modal.Footer>
        </Modal >
    )
};
const SignatureDisclaimer = () => <div className='text-primary text-start'>
    <br />
    By providing my electronic signature here, I acknowledge that I have read and agree to the following: My electronic signature will be applied by the Pet Pass Hospital system to where I might otherwise apply my physical signature including but not limited to:
    <ul>
        <li>Patient Charts,</li>
        <li>Visit Summaries,</li>
        <li>Written Prescriptions,</li>
        <li>Rabies Certificates,</li>
        <li>Medical Certificates,</li>
        <li>etc. (collectively “Documents”)</li>
    </ul>
    <div className="mt-n3">when such Documents are finalized for clients to check out or otherwise pay for veterinary services.</div>
    <br />
    <strong>Documents will be locked after 48 hours.</strong> Personal information, including my signature will be handled in accordance with the Petco Animal Supplies Stores, Inc. Privacy Policy for Partners & Independent Contractors and/or for Job Applicants, Candidates, and Members of our Talent Pool.
</div >
